import axios from "axios";
import { BASE_URL, SITE_STORAGE } from "./Constants.";

const headers = { "X-Custom-Header": "foobar" };
if (SITE_STORAGE.getItem("authToken")) {
  headers.Authorization = `Bearer ${SITE_STORAGE.getItem("authToken")}`;
  headers["TimezoneOffset"] = new Date().getTimezoneOffset();
  headers["Access-Control-Allow-Origin"] = "*";
}
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: headers,
});

instance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },

  (error) => {
    // no response means timeout or network failure, so check it before reading status
    if (error.response && error.response.status === 403) {
      SITE_STORAGE.removeItem("userData");
    }
    // reject so serviceProvider can classify the error instead of losing it
    return Promise.reject(error);
  }
);

export default instance;
